<clr-main-container>
  <app-navbar [loading]="routeLoading"></app-navbar>
  <router-outlet></router-outlet>
</clr-main-container>

<clr-modal
  id="loading-modal"
  [clrModalSize]="'md'"
  [(clrModalOpen)]="loadingModal"
>
  <h3 class="modal-title">Loading...</h3>
  <div class="modal-body">
    <span class="spinner spinner-lg"></span>
  </div>
</clr-modal>

<app-loading></app-loading>
<app-message-dialog
  (MessageDialogOutput)="
    messageDialogService.$MessageDialogSubject.next($event)
  "
  [MessageDialogTitle]="messageDialogService.MessageDialogTitle"
  [MessageDialogMessage]="messageDialogService.MessageDialogMessage"
  [ShowCancel]="messageDialogService.ShowCancel"
></app-message-dialog>
